/** Recruitment-stage choices for a player (ProspectProfile) contact. Value equals display label. */
export const RECRUITMENT_STAGES = ["Foundational", "Promotional", "Decision"] as const;
